import { startValues } from "./DrawerAnimationContext";

export const navigatorDefaultProps = (props = {}) => ({
    screenOptions: {
        headerShown: false,
        drawerType: props.showDrawer ? "permanent" : "front",
        drawerStyle: {
            width: startValues.width,
            left: props.showDrawer ? 0 : startValues.width * -1,
        },
    },
});